export enum GoalKeyResultMeasureUnitPlacement {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER'
}